var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProhibited(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.875 0C4.011 0 0.875 3.136 0.875 7C0.875 10.864 4.011 14 7.875 14C11.739 14 14.875 10.864 14.875 7C14.875 3.136 11.739 0 7.875 0ZM2.275 7C2.275 3.906 4.781 1.4 7.875 1.4C9.17 1.4 10.36 1.841 11.305 2.583L3.458 10.43C2.716 9.485 2.275 8.295 2.275 7ZM7.875 12.6C6.58 12.6 5.39 12.159 4.445 11.417L12.292 3.57C13.034 4.515 13.475 5.705 13.475 7C13.475 10.094 10.969 12.6 7.875 12.6Z",
    fill: "#94A6B8"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProhibited);
export default __webpack_public_path__ + "static/media/prohibited.f1aec652836724278f20e181814b91b6.svg";
export { ForwardRef as ReactComponent };